const CIS_COOKIE = 'cisId'
const FEATURE_TYPE_KEY = 'FT_'

const outOfStockLabel = {
  icon: 'out_of_stock',
  message: 'Out of stock'
}

const checkItemAvailability = messageKey => {
  const unavailableKeys = ['OUT_OF_STOCK', 'NOT_AVAILABLE']
  const isUnavailable = unavailableKeys.some(key => messageKey.includes(key))

  return isUnavailable
}

const replaceIcon = availability => {
  const { messageKey = '', icon = '' } = availability || {}
  const replaceIconKeys = [
    'COLLECTION_FROM_TODAY_AT_TIME',
    'COLLECTION_FROM_TOMORROW_AT_TIME',
    'COLLECTION_FROM_DATE',
    'FT_30_DELIVERY'
  ]

  const isMatched = replaceIconKeys.some(key => messageKey.includes(key))

  return isMatched ? 'tick' : icon
}

// Displays the product labels for delivery & collection
const formatAvailabilityMessages = availability => {
  const { collection = [], delivery = {} } = availability || {}

  const collectionKey = collection[0]?.messageKey || ''
  const deliveryKey = delivery?.messageKey || ''

  const collectionLabels =
    collection.length > 0
      ? {
          icon: replaceIcon(collection[0] || {}),
          message: collection[0].text || ''
        }
      : {}

  const deliveryLabels = delivery
    ? {
        icon: replaceIcon(delivery || {}),
        message: delivery.text || ''
      }
    : {}

  const isCollectionUnavailable = checkItemAvailability(collectionKey)
  const isDeliveryUnavailable = checkItemAvailability(deliveryKey)

  if (isCollectionUnavailable && isDeliveryUnavailable) {
    return [outOfStockLabel]
  }

  const isFeatureType = collectionKey.indexOf(FEATURE_TYPE_KEY) === 0 && deliveryKey.indexOf(FEATURE_TYPE_KEY) === 0

  // Both fufilment methods are available
  if (!isCollectionUnavailable && !isDeliveryUnavailable) {
    if (isFeatureType) {
      // Collection and delivery messages are same for feature type products, so show one
      return [collectionLabels || deliveryLabels]
    }
    return [collectionLabels, deliveryLabels]
  }
  // Then either one or both are unavailable
  return isDeliveryUnavailable ? [collectionLabels] : [deliveryLabels]
}

export { CIS_COOKIE, formatAvailabilityMessages }
